var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import get from 'lodash.get';
import React, { useContext } from 'react';
import Analytics from '../../analytics/Analytics';
import { useShopConfig } from '../../hooks/useShopConfig';
import ChannelContext from '../ChannelContext';
import FlightNostoProduct from '../nosto/FlightNostoProduct';
import ProductVariationProvider from '../ProductVariationProvider/ProductVariationProvider';
import { StructuredProductData } from '../StructuredData';
const mockProduct = {
    articleNumber: '',
    images: [
        {
            sizes: []
        }
    ],
    variants: {
        options: []
    }
};
function getProduct(result) {
    const routeObject = get(result, 'data.route.object');
    const dataProduct = get(result, 'data.product');
    return {
        product: routeObject || dataProduct || mockProduct,
        cacheHit: !!(routeObject || dataProduct)
    };
}
const ProductRoute = (props) => {
    const { component: ProductPage } = props, rest = __rest(props, ["component"]);
    const { product, cacheHit } = getProduct(props.result);
    const { structuredData } = useShopConfig();
    const { selectedChannel } = useContext(ChannelContext);
    const disableStructuredProductData = structuredData
        ? !!structuredData.disableDefaultProductData
        : false;
    return (React.createElement(React.Fragment, null,
        cacheHit && (React.createElement(React.Fragment, null,
            React.createElement(Analytics, { event: trackProductEvent({ action: 'view', product }) }),
            !disableStructuredProductData && (React.createElement(StructuredProductData, { product: product })))),
        React.createElement(ProductVariationProvider, { product: product },
            React.createElement(ProductPage, Object.assign({}, rest, { product: product, cacheHit: cacheHit })),
            get(selectedChannel, 'settings.nostoAccountId') && (React.createElement(FlightNostoProduct, null)))));
};
export default ProductRoute;
//# sourceMappingURL=ProductRoute.js.map